import request from '@/utils/httpRequest'

// 发展历程
export function ApiWebAboutHisList () {
  return request({
    url: request.adornUrl('/web/office/company/history/list'),
    method: 'get'
  })
}
// 荣誉与资质
export function ApiWebAboutHonorList () {
  return request({
    url: request.adornUrl('/web/office/company/honor/list'),
    method: 'get'
  })
}

// 关于集百优
export function ApiWebAboutCompanyData () {
  return request({
    url: request.adornUrl('/web/office/company/index'),
    method: 'get'
  })
}

// 关于我们顶部背景图
export function ApiWebBackdropImg () {
  return request({
    url: request.adornUrl('/web/office/company/backdrop/img'),
    method: 'get',
    params: request.adornParams()
  })
}


// WEBPACK FOOTER //
// ./src/api/aboutus.js